import type { Theme } from '@mui/material';
import { StyleObj } from '../../@types';
import { SkinStylesMap } from '../../hooks/useSkinStyles';
import { SKIN } from '../../types/enums';
import { neobetRaisedActionButtonStyles } from './neobetRaisedActionButton';

const BUTTON_HEIGHT = 44;

const DEFAULT_STYLES: StyleObj = {
  placeBetButton: {
    minHeight: BUTTON_HEIGHT,
    borderRadius: 0,
    ':disabled': {
      '& span': {
        color: 'rgba(0, 0, 0, 0.26)',
      },
    },
  },
  updateStakeButton: {
    minHeight: BUTTON_HEIGHT,
    backgroundColor: 'primary.500',
    borderRadius: 0,
  },
  acceptChangesButton: {
    minHeight: BUTTON_HEIGHT,
    backgroundColor: 'info.600',
    color: 'neutral.800',
    ':hover': {
      backgroundColor: 'info.500',
    },
    borderRadius: 0,
  },
};

const NEOBET_BUTTON_TEXT = {
  color: 'neutral.25',
  fontWeight: 900,
  letterSpacing: 0,
  lineHeight: 1.15,
  overflow: 'visible',
  WebkitTextStroke: (t: Theme) => `2px ${t.palette.primary[700]}`,
  textShadow: (t: Theme) => `0 2px 0 ${t.palette.primary[700]}`,
};

const NEOBET_BUTTON_BASE = {
  ...neobetRaisedActionButtonStyles.button,
  ...neobetRaisedActionButtonStyles.variants.form,
  borderRadius: 1,
  typography: 'h5',
  '& .MuiTypography-root': NEOBET_BUTTON_TEXT,
  '&.Mui-disabled .MuiTypography-root': {
    color: 'neutral.200',
    WebkitTextStroke: (t: Theme) => `2px ${t.palette.neutral[800]}`,
    textShadow: (t: Theme) => `0 2px 0 ${t.palette.neutral[800]}`,
  },
};

const NEOBET_STYLES: StyleObj = {
  ...DEFAULT_STYLES,
  placeBetButton: {
    ...NEOBET_BUTTON_BASE,
  },
  updateStakeButton: {
    ...NEOBET_BUTTON_BASE,
  },
  acceptChangesButton: {
    ...NEOBET_BUTTON_BASE,
  },
  placeBetAmount: {
    color: 'neutral.25',
    fontWeight: 800,
  },
};

export const BETSLIP_PLACE_BET_BUTTON_SKIN_STYLES: SkinStylesMap<StyleObj> = {
  [SKIN.BET365]: DEFAULT_STYLES,
  [SKIN.GOLA]: DEFAULT_STYLES,
  [SKIN.NEOBET]: NEOBET_STYLES,
};
